import { render, staticRenderFns } from "./historyreport.vue?vue&type=template&id=f3cf7e16&scoped=true&"
import script from "./historyreport.vue?vue&type=script&lang=js&"
export * from "./historyreport.vue?vue&type=script&lang=js&"
import style0 from "./historyreport.vue?vue&type=style&index=0&id=f3cf7e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cf7e16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VIcon,VRow})
